import { useEffect, useMemo } from 'react';
import { NewDropdown } from 'app/components/ui';
import { useDocumentTaxonomyConfig, useTaxonomyLanguages } from 'entities/tag';
import { useTagDisplay } from 'app/state/contexts/TagContext';
import { i18nDynamic } from 'shared/i18n';
import LanguageIcon from 'shared/ui/LanguageIcon';

export const TagLanguageDropdown = ({ documentSuperId }: { documentSuperId?: number }) => {
  const { tagLanguage, setTagLanguage, setAvailableTagLanguages } = useTagDisplay();
  const { data: taxonomyConfig } = useDocumentTaxonomyConfig(documentSuperId);
  const taxonomyId = taxonomyConfig?.taxonomySelections?.find((t) => t.isActive)?.taxonomyId ?? taxonomyConfig?.taxonomySelections?.[0]?.taxonomyId;
  const { data: availableLanguages } = useTaxonomyLanguages(documentSuperId, taxonomyId);

  const options = useMemo(
    () =>
      (availableLanguages?.length ? availableLanguages : ['sv', 'en']).map((lang) => ({
        label: i18nDynamic(`lang:${lang}`),
        value: lang,
        icon: <LanguageIcon language={lang} />,
      })),
    [availableLanguages]
  );

  useEffect(() => {
    setAvailableTagLanguages(availableLanguages);
  }, [availableLanguages, setAvailableTagLanguages]);

  return <NewDropdown currentValue={tagLanguage} options={options} onUpdate={(value: string) => setTagLanguage(value)} />;
};
